'use client';

import WifiOffIcon from '@mui/icons-material/WifiOff';
import { Box, Typography } from '@mui/material';

import { useT } from '@/hooks';
import { colors } from '@/styles/theme';

export function SocketDisconnectedBanner() {
  const { t } = useT();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 2,
        py: 0.75,
        mb: 1.5,
        borderRadius: '10px',
        bgcolor: colors.warning.bg,
        border: `1px solid ${colors.warning.border}`,
      }}
    >
      <WifiOffIcon sx={{ fontSize: '0.95rem', color: colors.warning.main }} />
      <Typography sx={{ fontSize: '0.8rem', color: colors.warning.main, fontWeight: 500 }}>
        {t('socket.disconnected')}
      </Typography>
      <Box
        sx={{
          ml: 'auto',
          width: 6,
          height: 6,
          borderRadius: '50%',
          bgcolor: colors.warning.main,
          '@keyframes reconnectPulse': {
            '0%, 100%': { opacity: 1 },
            '50%': { opacity: 0.2 },
          },
          animation: 'reconnectPulse 1.2s ease-in-out infinite',
        }}
      />
    </Box>
  );
}
